module.exports = __webpack_public_path__ + "img/index_quick1.4f0a0877.jpg";